import React from "react";
import { Modal } from "react-bootstrap";
import { Button } from "@/fm/components/dashboard_button";

export const LEAVE_CONFIRM_MESSAGE =
  "You have unsaved changes. Do you want to discard them?";

interface LeaveEditPageModalProps {
  show: boolean;
  onCancel: () => void;
  onDiscard: () => void;
  message?: string;
}

export function LeaveEditPageModal({
  show,
  onCancel,
  onDiscard,
  message = LEAVE_CONFIRM_MESSAGE,
}: LeaveEditPageModalProps) {
  return (
    <Modal
      show={show}
      backdrop="static"
      keyboard={false}
      centered
      onHide={onCancel}
    >
      <Modal.Header closeButton>
        <Modal.Title className="fs-5">Confirmation</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>{message}</p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onDiscard}>
          Discard
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
